import { Space, Tabs, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { ServicePricesTab } from "../components/ServicePricesTab.tsx";
import { TariffsTab } from "../components/TariffsTab.tsx";
import { TeacherRatesTab } from "../components/TeacherRatesTab.tsx";

/** Versioned billing rules (bd-2sz.2): tariffs, service prices and the teacher rate table. Read with billing.read, managed with billing.manageRules. */
export function BillingRulesPage() {
  const { t } = useTranslation();
  return (
    <Space orientation="vertical" size="middle" style={{ width: "100%" }}>
      <Typography.Title level={3} style={{ margin: 0 }}>
        {t("billing.title")}
      </Typography.Title>
      <Typography.Text type="secondary">{t("billing.hint")}</Typography.Text>
      <Tabs
        defaultActiveKey="tariffs"
        destroyOnHidden
        items={[
          { key: "tariffs", label: t("billing.tabs.tariffs"), children: <TariffsTab /> },
          { key: "services", label: t("billing.tabs.services"), children: <ServicePricesTab /> },
          { key: "rates", label: t("billing.tabs.rates"), children: <TeacherRatesTab /> },
        ]}
      />
    </Space>
  );
}
